import { createSlice } from '@reduxjs/toolkit';
import { isExpired } from 'react-jwt';



const initialState = {
    usuario: null,
    idUsuario: null,
    idRol: null,
    token: null,
    isLogin: 1,
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        updConfig: (state, action) => {
            state = Object.assign(state, action.payload);
        },
        resetConfig: () => initialState,
    },
});

export const selectRol = (state) => state.config.idRol;
export const selectConfig = (state) => state.config;
export const selectToken = (state) => state.config.token;

export const { updConfig, resetConfig } = configSlice.actions;

export const secureRequest = () => async (_, getState) => {
    const token = getState().auth.token;
    if (!token || !isExpired(token)) {
        //dispatch(logout());
    } else {
        // Continue with the request
    }
};

export const logout = () => async (dispatch, getState) => {
    const navigate = getState();
        dispatch(resetConfig());
    navigate && navigate(`/login`, { replace: true, state: { time: Date.now() } });
};

export default configSlice.reducer;
